<template>
  <div class="" id="top" v-if="wording && Object.keys(wording).length > 0">
    <div class="banner pb-1 offset-lg-1 d-print-none" v-if="!fullscreen && !isLoginRoute"
         v-bind:class="isMobile() ? '' : 'offset-lg-1'">
      <img src="./assets/img/banner.png" class="img-fluid d-block ms-lg-3">
    </div>
    <div class="d-print-none" v-if="setting.nav_search === true && !isLoginRoute">
      <div class="row pb-2 pt-2 ps-0 pe-0 me-0 ms-0" v-if="!fullscreen">
        <div class="col" v-bind:class="isMobile() ? 'col-9' : 'col-lg-7 offset-lg-1'"></div>
        <div class="col-md-3">
          <div class="input-group">
            <input type="text" class="form-control" :placeholder="_.nav_search" v-model="search"
                   v-on:keyup.enter="doSearch()">
            <button class="btn bg-white border-top border-bottom" v-on:click="resetSearch()"
                    v-if="search.length > 0">
              <icon :icon="['far', 'times']"/>
            </button>
            <div class="input-group-text">
              <icon :icon="['far', 'search']" v-on:click="doSearch()"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-primary d-print-none" v-if="!fullscreen && !isLoginRoute">
      <nav class="col navbar navbar-expand-md navbar-dark ps-0 pe-2 mb-3 font-weight-bold"
           v-bind:class="isMobile() ? 'col-12' : 'col-10 offset-1'">
        <ul class="navbar-nav nav-pills float-start pointer-click" v-on:click="search = ''">
          <router-link class="nav-link d-flex" to="/home"
                       v-bind:class="$route.name === 'home' ? '' : 'router-link-active'">
            <icon :icon="['fad', 'home']" class="fa-3x"/>
            <span class="my-auto">&nbsp;{{ _.nav_home }}</span>
          </router-link>
        </ul>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler"
                aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarToggler">
          <ul class="navbar-nav nav-pills ms-lg-5 text-lg-center">
            <li class="nav-link d-flex pointer-click" data-bs-toggle="offcanvas" v-if="setting.nav_session === true"
                data-bs-target="#offcanvasTopGroupSelectionSessions"
                v-bind:class="selectedView === 'session' && $route.name !== 'home' ? '' : 'router-link-active'">
              <icon :icon="['fad', 'screen-users']" class="fa-3x my-auto"/>
              <div class="my-auto d-inline-flex">&nbsp;{{ _.nav_sessions }}</div>
            </li>
            <li class="nav-link d-flex pointer-click" data-bs-toggle="offcanvas" v-if="setting.nav_theme === true"
                data-bs-target="#offcanvasTopGroupSelectionThemes"
                v-bind:class="selectedView === 'theme' && $route.name !== 'home' ? '' : 'router-link-active'">

              <icon :icon="['fad', 'layer-group']" class="fa-3x my-auto"/>
              <div class="my-auto d-inline-flex">&nbsp;{{ _.nav_topics }}</div>
            </li>
            <li class="nav-link d-flex pointer-click" data-bs-toggle="offcanvas" v-if="setting.nav_author === true"
                data-bs-target="#offcanvasTopGroupSelectionAuthors"
                v-bind:class="selectedView === 'author' && $route.name !== 'home' ? '' : 'router-link-active'">

              <icon :icon="['fad', 'users']" class="fa-3x my-auto"/>
              <div class="my-auto d-inline-flex">&nbsp;{{ _.nav_authors }}</div>
            </li>
            <li class="nav-link d-flex pointer-click" v-if="setting.nav_title === true"
                v-bind:class="selectedView === 'title' && $route.name !== 'home' ? '' : 'router-link-active'"
                v-on:click="setViewAndGo('title')"
            >
              <icon :icon="['fad', 'sort-alpha-down']" class="fa-3x my-auto"/>
              <div class="my-auto d-inline-flex">&nbsp;{{ _.nav_titles }}</div>
            </li>
          </ul>
          <ul class="navbar-nav nav-pills ms-auto d-none d-lg-inline-flex">
            <button class="btn btn-link btn-primary text-bg-primary d-flex" data-bs-toggle="modal"
                    v-if="setting.nav_sort === true"
                    data-bs-target="#modalPosterSort">
              <icon :icon="['fad', 'arrow-down-arrow-up']" class="fa-3x my-auto"/>
              <div class="my-auto d-inline-flex">&nbsp;{{ _.nav_sort }}</div>
            </button>
          </ul>
        </div>
      </nav>
    </div>
    <div>
      <router-view style="min-height:500px;"
                   v-if="isLoginRoute || (posters && Object.keys(posters).length > 0)"
                   :key="$route.fullPath"/>
      <Loader v-else></Loader>
    </div>
    <div class="row d-print-none" v-if="setting && setting.posterwalk === true && !isLoginRoute">
      <div class="col">
        <div class="text-center pt-1 pb-1">
          <div class="mt-3 mb-1">
            <div
                style="">
              <img src="./assets/img/withposterwalk.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row border-top d-print-none" v-else-if="!isLoginRoute">
      <div class="col d-inline-flex text-center my-auto justify-content-center">
        <div class="text-center pt-1 mt-2 pb-1">
          <div class="mt-3 mb-1">
            <div
                style="margin-left:auto;margin-right:auto;width:240px;border:1px solid #d4d4d4;border-radius:6px;padding:12px 12px 12px 12px;text-align: center;">
              <img src="./assets/img/powered.svg" style="height:20px;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-print-none" v-if="!isLoginRoute">
      <div class="col text-center justify-content-center">
        <router-link class="nav-link my-auto d-inline-block" to="/impress">
          &nbsp;{{ _.footer_imprint }}
        </router-link>
        <router-link class="nav-link my-auto d-inline-block" to="/privacypolicy">
          &nbsp;{{ _.footer_policy }}
        </router-link>
      </div>
    </div>
    <div class="offcanvas offcanvas-top h-100" tabindex="-1" id="offcanvasTopGroupSelectionThemes"
         aria-labelledby="offcanvasTopLabel">
      <div class="offcanvas-header">
        <!--        <h5 class="offcanvas-title" id="offcanvasTopLabel">Select topic</h5>-->
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <GroupSelectionThemes v-on:push="goView()"></GroupSelectionThemes>
      </div>
    </div>
    <div class="offcanvas offcanvas-top h-100" tabindex="-1" id="offcanvasTopGroupSelectionSessions"
         aria-labelledby="offcanvasTopLabel">
      <div class="offcanvas-header">
        <!--        <h5 class="offcanvas-title" id="offcanvasTopLabel">Select topic</h5>-->
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <GroupSelectionSessions v-on:push="goView()"></GroupSelectionSessions>
      </div>
    </div>
    <div class="offcanvas offcanvas-top h-100" tabindex="-1" id="offcanvasTopGroupSelectionAuthors"
         aria-labelledby="offcanvasTopLabel">
      <div class="offcanvas-header">
        <!--        <h5 class="offcanvas-title" id="offcanvasTopLabel">Select topic</h5>-->
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <GroupSelectionAuthors v-on:push="goView()"></GroupSelectionAuthors>
      </div>
    </div>
    <div class="modal fade" id="modalPosterSort" tabindex="-1" aria-labelledby="modalPosterSortLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalPosterSortLabel">Poster sort</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <PosterSort/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalContact" tabindex="-1" aria-labelledby="modalContactLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalContactLabel">Contact</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <Mail :key="contactPoster"></Mail>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="staticBackdropTimeout" tabindex="-1" aria-labelledby="staticBackdropTimeout"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-secondary">
            <h1 class="modal-title" id="staticBackdropTimeoutLabel">Presentation</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body d-flex fw-bold">
            <div>Your presentation time has expired.</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import GroupSelectionThemes from "./views/groups/GroupSelectionThemes";
import GroupSelectionSessions from "./views/groups/GroupSelectionSessions";
import Loader from "./components/Loader";
import PosterSort from "./components/PosterSort";
import Mail from "./views/Mail";
import GroupSelectionAuthors from "./views/groups/GroupSelectionAuthors";

export default {
  components: {GroupSelectionAuthors, Mail, PosterSort, Loader, GroupSelectionThemes, GroupSelectionSessions},
  data: function () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapState([
      'posters', 'fullscreen', 'mode', "thumbnails", "selectedView", "contactPoster", "wording", "setting"
    ]),
    isLoginRoute() {
      return this.$route.path === '/login';
    },
  },
  methods: {
    ...mapActions('session', ['GET_SESSIONS']),
    ...mapMutations(['setSelectedView']),
    goView() {
      this.$router.push('view');
    },
    setViewAndGo(mode) {
      this.setSelectedView(mode);
      this.goView();
    },
    doSearch() {
      this.$store.state.loader = true;
      this.setSelectedView('search');
      if (this.search.length > 0) {
        this.$store.dispatch('TRACK_ACTION', {
          'value': this.search,
          'action': 'search',
          'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
        });
        let searchObject = {search: this.search}
        this.$store.dispatch('GET_POSTERS', searchObject);
        this.$router.push('view')
      } else {
        this.$router.push('/home')
      }
    },
    resetSearch() {
      this.search = '';
      this.$router.push('/home')
    },
  },
  created() {
    this.$store.state.loader = true;
    this.$store.dispatch('author/GET_AUTHORS');
    this.$store.dispatch('GET_ALL_RATINGS');
    this.$store.dispatch('GET_TOP5_VIEWS');
    this.$store.dispatch('GET_ALL_WORDING');
    this.$store.dispatch('GET_STATISTICS');
    this.$store.dispatch('GET_ALL_POSTERS');
    this.$store.dispatch('GET_DATAHELPER');
    this.$store.dispatch('GET_THEMES');
    this.$store.dispatch('GET_SETTING');
    this.GET_SESSIONS();
  }
}
</script>

<style lang="scss">
@import './assets/styles/custom-bootstrap.scss';
@import "~bootstrap/scss/bootstrap";
</style>
